/**
 * Página de Calendário - JurisPrazo
 * Visualização de prazos em formato de calendário
 */

import React, { useState, useEffect } from 'react';
import CalendarioPrazos from '../components/CalendarioPrazos';
import PrazoService from '../services/prazoService';

const CalendarioPage = ({ currentUser, onNavigate }) => {
  const [prazos, setPrazos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (currentUser?.uid) {
      loadPrazos();
    }
  }, [currentUser]);

  const loadPrazos = async () => {
    try {
      setLoading(true);
      const userPrazos = await PrazoService.getUserPrazos(currentUser.uid);
      setPrazos(userPrazos);
    } catch (error) {
      console.error('Erro ao carregar prazos:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-20">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-indigo-600 mx-auto mb-4"></div>
          <p className="text-slate-600">Carregando calendário...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      {/* Header da Página */}
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-slate-900">📅 Calendário de Prazos</h1>
        <p className="text-slate-600 mt-1">Visualize seus prazos de forma organizada</p>
      </div>

      {/* Calendário */}
      <div className="bg-white border border-slate-200 rounded-xl shadow-sm p-6">
        <CalendarioPrazos
          prazos={prazos}
          onDateClick={(date, prazosData) => {
            console.log('Data clicada:', date, prazosData);
          }}
          onPrazoClick={(prazo) => {
            console.log('Prazo clicado:', prazo);
          }}
        />
      </div>
    </div>
  );
};

export default CalendarioPage;
